import { useQuery, useMutation } from '@tanstack/react-query';
import { QueryKeys } from '@/types/query';
import {
  createNewPromoCode,
  disablePromoCode,
  DisablePromoCodeData,
  extendPromoCode,
  ExtendPromoCodeData,
  getTalononeCampaigns,
  getTalononePromoResponse,
  NewPromoCodeData,
} from '@/services/talonone';
import { toRQMutation, toRQQuery } from '@/utilities/service';

export function useTalononePromoResponse(clientId: string, page: number, pageSize: number, enabled: boolean) {
  return useQuery({
    queryKey: [QueryKeys.TALONONE_PROMO_RESPONSE, clientId, page, pageSize],
    queryFn: () => getTalononePromoResponse(clientId, page, pageSize),
    staleTime: Infinity,
    enabled,
  });
}

export function useTalononeCampaigns() {
  const { isFetching, isRefetching, data, refetch, remove } = useQuery({
    queryKey: [QueryKeys.TALONONE_CAMPAIGNS],
    queryFn: () => getTalononeCampaigns(),
    staleTime: Infinity,
  });

  return toRQQuery(data, isFetching, isRefetching, refetch, remove);
}

export function useTalononeNewPromoCode() {
  const { isLoading, data, mutate } = useMutation({
    mutationFn: (data: NewPromoCodeData) => createNewPromoCode(data),
  });

  return toRQMutation(data, isLoading, mutate);
}

export function useTalononeExtendPromoCode() {
  const { isLoading, data, mutate } = useMutation({
    mutationFn: (data: ExtendPromoCodeData) => extendPromoCode(data),
  });

  return toRQMutation(data, isLoading, mutate);
}

export function useTalononeDisablePromoCode() {
  const { isLoading, data, mutate } = useMutation({
    mutationFn: (data: DisablePromoCodeData) => disablePromoCode(data),
  });

  return toRQMutation(data, isLoading, mutate);
}
